<ng-container *ngIf="textKey === 'PROXY_TITLE'" i18n>Stellen Sie den Antrag für sich selbst?</ng-container>
<ng-container *ngIf="textKey === 'YES'" i18n>Ja</ng-container>
<ng-container *ngIf="textKey === 'NO'" i18n>Nein, ich stelle diesen Antrag stellvertretend für eine andere Person</ng-container>

<!-- BIOMETRIE C-VISUM -->
<ng-container *ngIf="textKey === 'BIOMETRIE_FINGERABDRUECKE_TITLE'" i18n>Wurden Ihre Fingerabdrücke bereits für die Zwecke eines Antrags auf ein Schengen-Visum erfasst?</ng-container>
<ng-container *ngIf="textKey === 'BIOMETRIE_FINGERABDRUECKE_YES'" i18n>Ja</ng-container>
<ng-container *ngIf="textKey === 'BIOMETRIE_FINGERABDRUECKE_NO'" i18n>Nein</ng-container>

<!-- CONTACT DATA -->
<ng-container *ngIf="textKey === 'KONTAKTDATEN_WOHNSITZ_TITLE'" i18n>Haben Sie Ihren Wohnsitz in einem anderen Staat als dem, dessen Staatsangehörigkeit Sie aktuell besitzen?</ng-container>
<ng-container *ngIf="textKey === 'KONTAKTDATEN_WOHNSITZ_YES'" i18n>Ja</ng-container>
<ng-container *ngIf="textKey === 'KONTAKTDATEN_WOHNSITZ_NO'" i18n>Nein</ng-container>
